import { render, staticRenderFns } from "./BackupsDataTable.vue?vue&type=template&id=bf747ee4&scoped=true&"
import script from "./BackupsDataTable.vue?vue&type=script&lang=ts&"
export * from "./BackupsDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./BackupsDataTable.vue?vue&type=style&index=0&id=bf747ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf747ee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
